import Layout from './Layout';
import Game from './Game';
import Login from './Login'

export default {
    Layout,
    Game,
    Login,
};
